module.exports = __webpack_public_path__ + "static/media/publicacoes.dbce2683.jpg";